import { BaseSlide } from '../BaseSlide/BaseSlide';
import { TransitionLeftProps } from './TransitionLeft.types';

/**
 * Component for providing the base slide to the snackbar.
 *
 * @param props - {@link BaseSlideProps props} description.
 */
export const TransitionLeft = ((props: TransitionLeftProps) => {
    return <BaseSlide {...props} direction={'left'} />;
});